import firebase from "../firebase";

const clients = firebase.ref("/clients");
const partners = firebase.ref("/partners");
const partnerCodes = firebase.ref("/partnerCodes");
import UtilService from "@/services/UtilService";


class ClientService {
  getAll(userInfo) {
    if(userInfo.Role === 'Partner Admin' || userInfo.Role === 'Partner Staff'){
      return clients.orderByChild("Partner").equalTo(userInfo['PartnerId']);
    } else {
      return clients.orderByChild("IsDeleted").equalTo(0);
    }
  }
  
  getById(Id) {
    var ref = clients.child('/'+Id);
    return ref;
  }

  getClientByCompany(Company) {
    return clients.orderByChild("CompanyName").equalTo(Company)
  }

  create(client) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    return clients.orderByChild("CompanyName").equalTo(client["CompanyName"]).once("value", snapshot => {
        if (snapshot.exists()){
          return null;
        } else {
            var newPostRef = clients.push();
            var Id = newPostRef.key;
            client['Id'] = Id;
            client["CreatedDate"] = client["ModifiedDate"] =  UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);

            return clients.orderByChild("ClientNumber").limitToLast(1).once("value", client_snapshot => {
                if (client_snapshot.exists()){
                  const maxClient = Object.values({...client_snapshot.val()})[0];
                   client['ClientNumber'] = (maxClient && maxClient.ClientNumber)? (parseInt(maxClient.ClientNumber) + 1) : 1;
                  return clients.child(Id).set(client);
                } else {
                  client['ClientNumber'] = 1; 
                  return clients.child(Id).set(client);
                }
            });
        }
    });
  }

  update(key, client) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    client["ModifiedDate"] =  UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);
    return clients.child(key).update(client);
  }

  delete(key) {
    return clients.child(key).update({ 
      IsDeleted: 1
     });
  }

  deleteAll() {
    return clients.remove();
  }

  incClientCount(id) {
    let clientModel = {}
    let count
      return partners.orderByChild("Id").equalTo(id).once("value", snapshot => {
        if (snapshot.exists()){
          clientModel = {...snapshot.val()}
            if(clientModel[id].ClientCount){
              count = clientModel[id].ClientCount
              count = count + 1
              return partners.child(id).update({ 
                ClientCount: count 
              });
            }else{
              count = 0
              count = count + 1
              return partners.child(id).update({ 
                ClientCount: count 
              });
            }
        }
    })
  }

  decClientCount(id){
    let clientModel = {}
    let count
    return partners.orderByChild("Id").equalTo(id).once("value", snapshot => {
      if (snapshot.exists()){
        clientModel = {...snapshot.val()}
          if(clientModel[id].ClientCount){
            count = clientModel[id].ClientCount
            count = count - 1
            return partners.child(id).update({ 
              ClientCount: count 
             });
          }else{
            count = 0
            return partners.child(id).update({ 
              ClientCount: count 
             });
          }
      }
  })
  }

  getPartnerVal(){
    return partners
  }

  getPartnerIdFromClients(id){
    return clients.orderByChild("Id").equalTo(id)
  }

  getClientById(id){
    return clients.orderByKey().equalTo(id);
  }

  getLastRecordKey(){
    return clients.orderByValue().limitToLast(1)
  }

}

export default new ClientService();
